




import {Component} from "vue-property-decorator";
import {Chart, ChartItem} from "chart.js";
import BaseStationChart from "@/components/bss/BaseStationChart.vue";

@Component({})
export default class BaseStationLineChart extends BaseStationChart {

  protected async createChart(ctx: ChartItem) {
    this.chart = new Chart(ctx, {
      type: 'line',
      data: this.chartData,
      options: this.chartOptions,
    });
  }
}
